import React from 'react';
import { useNavigate } from 'react-router-dom';
import EngineerLayout from './EngineerLayout';
import { 
    FaArrowLeft, 
    FaArrowRight,
    FaClipboardList,
    FaUsers
} from 'react-icons/fa';

const ActionCard = ({ title, subtitle, icon, onClick, colorClass, iconColor }) => (
    <div 
        onClick={onClick}
        className="group cursor-pointer bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col items-start overflow-hidden h-full"
    >
        <div className={`h-1.5 w-full ${colorClass}`}></div>
        <div className="p-8 flex flex-col items-start space-y-6 flex-grow text-left">
            <div className={`p-4 rounded-xl ${iconColor} bg-opacity-10 transition-transform duration-500 group-hover:scale-110 shadow-sm`}>
                <div className={`text-3xl ${iconColor.replace('bg-', 'text-')}`}>
                    {icon}
                </div>
            </div>
            <div>
                <h3 className="text-xl font-bold text-gray-800 tracking-tight mb-2 font-marathi">
                    {title}
                </h3>
                <p className="text-gray-400 text-sm font-bold font-marathi leading-relaxed">
                    {subtitle}
                </p>
            </div>
        </div>
        <div className="w-full h-12 px-8 flex items-center justify-between border-t border-gray-50 bg-gray-50/30 group-hover:bg-gray-50 transition-colors font-marathi">
            <span className="text-gray-400 text-xs font-bold uppercase tracking-widest">निवडा</span>
            <FaArrowRight className="text-gray-300 group-hover:text-gray-600 transition-colors" size={14} />
        </div>
    </div>
);

const EngineerTotalWorkDistributionMenu = () => {
    const navigate = useNavigate();

    const distributionOptions = [
        { 
            title: "सुबे  वर्क्स वितरण", 
            subtitle: "उप-अभियंता प्रकल्पांसाठी व्यापक वितरण सारांश पहा",
            icon: <FaClipboardList />, 
            path: "/engineer/sub-works-distribution-list", 
            color: "bg-blue-600",
            iconColor: "bg-blue-600"
        },
        { 
            title: "सोसायटी वर्क्स वितरण", 
            subtitle: "मजूर सोसायट्यांसाठी अधिकृत वाटप आणि वितरण निकाल",
            icon: <FaUsers />, 
            path: "/engineer/society-works-distribution-list", 
            color: "bg-[#1a3c34]",
            iconColor: "bg-[#1a3c34]"
        }
    ];

    return (
        <EngineerLayout>
            <div className="p-6 md:p-8 bg-gray-50/30 min-h-screen">
                {/* Premium Dark Header Card */}
                <div className="bg-[#1a1c23] rounded-3xl p-10 mb-12 shadow-2xl relative overflow-hidden group font-marathi">
                    <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-32 -mt-32 blur-3xl transition-transform duration-1000 group-hover:scale-110"></div>
                    <div className="absolute bottom-0 left-0 w-32 h-32 bg-blue-600/10 rounded-full -ml-16 -mb-16 blur-2xl"></div>
                    
                    <div className="relative flex flex-col md:flex-row justify-between items-center gap-6">
                        <div className="flex items-center gap-6">
                            <button 
                                onClick={() => navigate('/engineer/reports-menu')}
                                className="bg-white/10 hover:bg-white/20 text-white p-4 rounded-2xl transition-all hover:scale-110 active:scale-90 backdrop-blur-sm border border-white/10"
                            >
                                <FaArrowLeft size={18} />
                            </button>
                            <div>
                                <h1 className="text-4xl font-bold text-white tracking-tight mb-3">एकूण कामांचे वितरण</h1>
                                <p className="text-gray-400 font-bold text-sm tracking-widest uppercase flex items-center gap-2">
                                    <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
                                    वितरण जीवनचक्र आणि मागोवा
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Grid Container */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {distributionOptions.map((option, index) => (
                        <ActionCard 
                            key={index}
                            title={option.title}
                            subtitle={option.subtitle}
                            icon={option.icon}
                            colorClass={option.color}
                            iconColor={option.iconColor}
                            onClick={() => option.path !== "#" && navigate(option.path)}
                        />
                    ))}
                </div>
            </div>

            <style>{`
                .font-marathi {
                    font-family: 'Hind', sans-serif;
                }
                @import url('https://fonts.googleapis.com/css2?family=Hind:wght@400;500;600;700&display=swap');
            `}</style>
        </EngineerLayout>
    );
};

export default EngineerTotalWorkDistributionMenu;
